import {
  AccordionHeader,
  Box,
  Collapse,
  Flex,
  Heading,
} from '@joinrepublic/dls-ui-kit';

import { ServiceItem } from './service-item';
import { IService } from './types';

interface IServiceSectionProps {
  service: IService;
  isExpanded: boolean;
}

export const ServiceSection = ({
  service,
  isExpanded,
}: IServiceSectionProps) => {
  const Icon = service.icon;

  return (
    <>
      <AccordionHeader
        px={0}
        py={5}
        color="grey.500"
        _hover={{ color: 'grey.900' }}
      >
        <Flex align="center" gridGap={3} color="grey.900">
          <Icon boxSize={{ base: 6, sm: 10 }} />
          <Heading as="h3" size={{ base: 'title-xs', sm: 'title-sm' }}>
            {service.name}
          </Heading>
        </Flex>
      </AccordionHeader>

      <Collapse
        in={isExpanded}
        transition={{
          enter: { duration: 0.3 },
          exit: { duration: 0.2 },
        }}
      >
        <Box pb={{ base: 6, sm: 0 }}>
          {service.items.map((item, index) => (
            <ServiceItem key={index} item={item} />
          ))}
        </Box>
      </Collapse>
    </>
  );
};
